<div class="dashboard-section dashboard-section-shadow margin-top" *ngIf="data !== null">
  <div class="key-questions-section">
    <ng-container *ngIf="hasData; else noDataTemplate">
      <div class="key-questions-grid">
        <!-- Left: percentage-type questions stacked vertically -->
        <div class="percentage-column" *ngIf="percentageQuestions.length">
          <div *ngFor="let q of percentageQuestions" class="percentage-block">
            <ng-container *ngIf="q.respondentCount > 0; else noQuestionData">
              <span class="percentage-value">{{ q.percentage }} %</span>
              <p class="percentage-label" [innerHTML]="q.label"></p>
            </ng-container>
            <ng-template #noQuestionData>
              <span class="no-data-text">Aucune donnée pour l'instant</span>
              <p class="percentage-label" [innerHTML]="q.label"></p>
            </ng-template>
          </div>
        </div>

        <!-- Each distribution-type question gets its own column -->
        <div *ngFor="let q of distributionQuestions" class="distribution-column">
          <p class="distribution-title" [innerHTML]="q.label"></p>
          <div class="chart-container">
            <ng-container *ngIf="q.respondentCount > 0; else noDistributionData">
              <app-vertical-bar-chart
                [data$]="getChartData$(q)"
                [labels]="getLabels(q)"
                [colors]="getColors(q)">
              </app-vertical-bar-chart>
            </ng-container>
            <ng-template #noDistributionData>
              <span class="no-data-text">Aucune donnée pour l'instant</span>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noDataTemplate>
      <div class="no-data-message">
        <span>Aucune donnée pour l'instant</span>
      </div>
    </ng-template>
  </div>
</div>
